import rootAPIs from '@/api/rootAPIs';

const ENV = process.env.VUE_APP_ENV || 'development';
const defaultEnv = import(`@/siteSettings/default/${ENV}`);

const state = {
  settings: {
    rebateConfig: {},
    styles: {},
    segment: {},
  },
};

const mutations = {
  /* eslint-disable no-param-reassign */
  setSiteSettings(siteSettingsState, { settingsConfig }) {
    siteSettingsState.settings = { ...settingsConfig };
  },
  /* eslint-enable no-param-reassign */
};

const actions = {
  /**
   * Set the current site settings from the given application id.
   *
   * @param applicationId The ID that will be used to request the config from the server
   */
  setCurrentUtility({ commit }, { applicationId }) {
    return rootAPIs.getUtilityConfig(applicationId)
      .then(result => commit('setSiteSettings', { settingsConfig: result.data }))
      .catch(() => (
        // Setting the default configuration due to an issue with the request
        defaultEnv.then(result => commit('setSiteSettings', { settingsConfig: result.default }))
      ));
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
